import {Observable, throwError as observableThrowError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {UserUtil} from '../../utils/UserUtil';
import {BadRequestError} from '../../errors/BadRequestError';
import {EntityConflictError} from '../../errors/EntityConflictError';
import {SessionExpiredError} from '../../errors/SessionExpiredError';
import {InternalServerError} from '../../errors/InternalServerError';
import {UnprocessableEntityError} from '../../errors/UnprocessableEntityError';
import {SessionExpiryErrorHandler} from '../../error-handlers/session-expiry-error-handler';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {UnverifiedMobileNumberError} from '../../errors/unverified-mobile-number.error';
import {EntityGoneError} from '../../errors/EntityGoneError';
import {customErrorKeyword} from '../../errors/error-code';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    private sessionExpiryErrorHandler: SessionExpiryErrorHandler;
    private userUtil: UserUtil;

    constructor(sessionExpiryErrorHandler: SessionExpiryErrorHandler, userUtil: UserUtil) {
        this.sessionExpiryErrorHandler = sessionExpiryErrorHandler;
        this.userUtil = userUtil;
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const observable = next.handle(req);
        return observable.pipe(catchError((err: any): Observable<any> => {
            return this.handleError(err);
        }));
    }

    public handleError(err: any): Observable<any> {
        if (err instanceof HttpErrorResponse) {
            switch (err.status) {
                case 400:
                    if (err.error && err.error.errors && err.error.errors[0].errorCode === 'FE-US-1000') {
                        return observableThrowError(new UnverifiedMobileNumberError());
                    }
                    if(customErrorKeyword.includes(err.error.key)){
                        return observableThrowError(new BadRequestError(err.error.message));
                    }
                    return observableThrowError(new BadRequestError());
                case 401:
                    if (this.userUtil.isUserLoggedIn()) {
                        this.sessionExpiryErrorHandler.handleError(new SessionExpiredError());
                    }
                    return observableThrowError(err);
                case 409:
                    return observableThrowError(err);
                case 422:
                    const responseBody = err.error;
                    return observableThrowError(new UnprocessableEntityError(responseBody ? responseBody.code : undefined));
                case 410:
                    return observableThrowError(new EntityGoneError());
                case 500:
                    if(customErrorKeyword.includes(err.error.key)){
                        return observableThrowError(new InternalServerError(err.error.message));
                    }
                    this.sessionExpiryErrorHandler.handleError(new InternalServerError());
                    return observableThrowError(err);
            }
        }
        return observableThrowError(err);
    }
}
